import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { inspectionTemplates } from "src/data/mockData";
import { CreateInspectionStep, InspectionTemplateDetail } from "src/data/types";
import { apiRequest } from "src/utils/apiRequest";

export type CreateInspectionState = {
  createInspectionSteps: Record<
    "inspectionDetails" | "configureQuestions",
    CreateInspectionStep
  >;
  inspectionTemplateDetail: InspectionTemplateDetail;
};
const initialInspectionTemplateDetail = {
  name: "",
  inspectionType: "",
  location: "",
  frequency: "",
  mandate: "",
  status: "Active",
};
const initialState: CreateInspectionState = {
  createInspectionSteps: {
    inspectionDetails: "present",
    configureQuestions: "future",
  },
  inspectionTemplateDetail: initialInspectionTemplateDetail,
};
/** Data Slice */
const { reducer, actions } = createSlice({
  name: "createInspection",
  initialState,
  reducers: {
    setCreateInspectionStep: (state, { payload }) => {
      const {
        step,
        currentStep,
      }: {
        step: "inspectionDetails" | "configureQuestions";
        currentStep: CreateInspectionStep;
      } = payload;
      state.createInspectionSteps[step] = currentStep;
    },
    updateInspectionDetails: (state, { payload }) => {
      const {
        label,
        value,
      }: { label: keyof InspectionTemplateDetail; value: string } = payload;
      state.inspectionTemplateDetail[label] = value;
    },
  },
  extraReducers: (builder) => {},
});

export const { setCreateInspectionStep, updateInspectionDetails } = actions;

export default reducer;
